<div class="layout-content p-0 pt-3" [ngClass]="layoutMarginResponsive()">
	<div *ngIf="(loading$ | async); else elseBlock">
		<!--Spinner-->
	</div>
	<ng-template #elseBlock>
		<div class="grid">
			<app-device-icon [device]="device" [class]="!onExtendedMobile() ? 'col-7' : 'col-10'" class="flex align-items-center justify-content-start"></app-device-icon>
			<app-device-button-bar [class]="!onExtendedMobile() ? 'col-5' : 'col-2 mt-1'" class="flex align-items-center justify-content-end"></app-device-button-bar>
			<app-device-tab-group class="col-12" [enableBreadcump]="true"></app-device-tab-group>
		</div>
	</ng-template>
</div>